// 用来存储全局 枚举字段的枚举

export const enum EnumerateEnum {
    yyRegion = "yy-region",

    openTongueUser = "open-tongue-user",
    openTongueQrCodeUid = "open-tongue-qr-code-uid",
    openTongueDeviceId = "open-tongue-device-id",
}